import type { EnumUnion } from "@dresscode-frontend/utility-types";
import { z } from "zod";

import { OrderDirection } from "@/constants/orderDirection";

import type { Devices } from "./-query/type";

export type DeviceGenreFilterKey = Devices["items"][number]["genre"];
export const DeviceGenreFilterKey = {
  WORKSTATION: "WORKSTATION",
  LAPTOP: "LAPTOP",
  MOBILE: "MOBILE",
  TABLET: "TABLET",
  MONITOR: "MONITOR",
  SERVER: "SERVER",
  OTHER: "OTHER",
} as const satisfies Record<DeviceGenreFilterKey, DeviceGenreFilterKey>;

export const DeviceCategoryFilterKey = {
  DECOMMISSIONED: "DECOMMISSIONED",
  ALL: "ALL",
  IN_STOCK: "IN_STOCK",
  IN_USED: "IN_USED",
  IN_PLACED: "IN_PLACED",
  IN_TROUBLED: "IN_TROUBLED",
  IN_DISTRIBUTION: "IN_DISTRIBUTION",
} as const;
export type DeviceCategoryFilterKey = EnumUnion<typeof DeviceCategoryFilterKey>;
export const TabKey = {
  ASSIGNED: DeviceCategoryFilterKey.IN_USED,
  PLACED: DeviceCategoryFilterKey.IN_PLACED,
  AVAILABLE: DeviceCategoryFilterKey.IN_STOCK,
  UNDER_MAINTENANCE: DeviceCategoryFilterKey.IN_TROUBLED,
  IN_DISTRIBUTION: DeviceCategoryFilterKey.IN_DISTRIBUTION,
  ALL: DeviceCategoryFilterKey.ALL,
  DECOMMISSIONED: DeviceCategoryFilterKey.DECOMMISSIONED,
} as const;
export type TabKey = EnumUnion<typeof TabKey>;

export const Columns = {
  DEVICE: "NAME",
  TYPE: "TYPE",
  MODEL: "MODEL",
  ASSIGNEE: "ASSIGNEE",
  ASSIGNMENT_RANGE: "ASSIGNMENT_RANGE",
  PREVIOUS_ASSIGNEE: "PREVIOUS_ASSIGNEE",
  PREVIOUS_ASSIGNMENT_RANGE: "PREVIOUS_ASSIGNMENT_RANGE",
  PLACE: "PLACE",
  PLACED_RANGE: "PLACED_RANGE",
  WAREHOUSING_PLACE: "WAREHOUSING_PLACE",
  WAREHOUSING_PLACE_RANGE: "WAREHOUSING_PLACE_RANGE",
  USER_PLACE: "USER_PLACE",
  DEVICE_STATUS: "DEVICE_STATUS",
  PROCUREMENT_DATE: "PROCUREMENT_RANGE",
  LAST_TROUBLED_DATE: "LAST_TROUBLED_DATE",
  LAST_TROUBLED_MEMO: "LAST_TROUBLED_MEMO",
  PROCUREMENT_TYPE: "PROCUREMENT_TYPE",
  ASSET_TAG: "ASSET_TAG",
  DEVICE_TAG: "DEVICE_TAG",
  MANUFACTURER: "MANUFACTURER",
  MEMO: "MEMO",
} as const;
export type Columns = EnumUnion<typeof Columns>;

export const TabKeySchema = z.nativeEnum(TabKey);

export const SearchSchema = z.object({
  orderDirection: z
    .nativeEnum(OrderDirection)
    .default(OrderDirection.ASC)
    .optional(),
  category: z.nativeEnum(DeviceCategoryFilterKey).default(TabKey.ALL),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  genres: z.array(z.nativeEnum(DeviceGenreFilterKey)).optional(),
  freeText: z.string().optional(),
  sortColumn: z
    .enum([
      Columns.DEVICE,
      Columns.MODEL,
      Columns.DEVICE_TAG,
      Columns.ASSET_TAG,
    ])
    .optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional(),
});
